import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, filter, map, Observable, of, Subscription, switchMap, tap } from 'rxjs';
import { Setting } from '../../common/settings';
import { RequestReviewerViewModel } from '../Model/requestReviewerViewModel';
import { RequestService } from '../services/requests.services';
import url from 'src/settings.json';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { UserInformation } from '../Model/userInformation';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ModifiedRequest } from '../Model/modifiedRequest';
import { ModifiedItem } from '../../common/modifiedItem';
import { OrganisationService } from '../../organisation/organisation/services/organisation.service';
import { ModeratorViewModel } from '../Model/moderatorViewModel';
import { ReviewerProgressViewModel } from '../Model/ReviewerProgressViewModel';

@Component({
  selector: 'app-request-reviewers',
  templateUrl: './request-reviewers.component.html',
  styleUrls: ['./request-reviewers.component.css']
})
export class RequestReviewersComponent implements OnInit, OnDestroy {
  @Input() requestId: number | undefined;
  @Input() canModify = false;
  @Input() project!: string;
  reviewersProgressList!: ReviewerProgressViewModel[];
  reviewersList!: RequestReviewerViewModel[];
  isListloading = false;
  displayedColumns: string[] = ['reviewer', 'relatedScope', 'isApprover', 'progress'];

  errorMessage = "";
  isEditable = false;
  displayedColumnsToEdit: string[] = ['reviewer', 'relatedScope', 'isApprover', 'action'];
  isReviewerLoading = false;
  addReviewerControl = new FormControl();
  reviewersfilteredOptions!: Observable<any>;
  setting: Setting = url;
  currentOrganisation: any;
  organisationSubscriber?: Subscription;
  currentUser!: UserInformation;
  newReviewersList: Array<RequestReviewerViewModel> = [];
  reviewersOptions: Array<UserInformation> = [];
  //moderatorsList!: ModeratorViewModel[];
  moderatorIds: Array<string> = [];
  isModified = false;
  isRequestor = false;
  isReviewerAddedSuccessfully = false;

  reviewRequest: ModifiedRequest = {
    requestId: 0,
    moderators: [],
    tasks: [],
    reviewers: [],
    modifiedItem: ModifiedItem.Reviewer
  }

  constructor(private readonly requestService: RequestService, private readonly http: HttpClient,
    private readonly organisationService: OrganisationService) {
    this.organisationSubscriber = this.organisationService.organisationEmitter.subscribe({
      next: (value: string) => {
        if (value === '') { this.currentOrganisation = this.organisationService.getLocalStorageItem("CurrentOrganisation") }
        else { this.currentOrganisation = value; }
      }
    });
    this.GetCurrentUser();
  }


  ngOnInit(): void {
    console.log("Requestid for Request-reviewers is " + this.requestId);
    this.getRequestReviewersProgress(Number(this.requestId));
    this.getRequestReviewers(Number(this.requestId));

    this.reviewersfilteredOptions = this.addReviewerControl.valueChanges.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      filter((value) => value !== ""),
      switchMap(val => {
        return this.filterReviewers(val)
      }))
  }

  ngOnDestroy(): void {
    this.organisationSubscriber?.unsubscribe();
  }

  getRequestReviewersProgress(id: number) {
    this.isListloading = true;
    this.requestService.getReviewersProgress(id).subscribe({
      next: (response: ReviewerProgressViewModel[]) => {
        this.reviewersProgressList = response;
      },
      error: (error: any) => {
        console.log(error)
      },
      complete: () => { this.isListloading = false; }
    });
  }

  getRequestReviewers(id: number) {
    this.isListloading = true;
    this.requestService.getrequestReviewers(id).subscribe({
      next: (response: RequestReviewerViewModel[]) => {
        this.reviewersList = response;
      },
      error: (error: any) => {
        console.log(error)
      },
      complete: () => { this.isListloading = false; }
    });
  }

  getRequestModerators(id: number) {
    this.requestService.getrequestModerators(id).subscribe({
      next: (response: ModeratorViewModel[]) => {        
        response.forEach((m) => {
          this.moderatorIds.push(m.moderatorId);
        });
      },
      error: (error: any) => {
        console.log(error)
      },
      complete: () => { }
    });
  }

  onEditClick() {
    this.isEditable = true;

    this.reviewersList.forEach((reviewer) => {
      this.newReviewersList.push(reviewer);
    });

    this.getRequestModerators(Number(this.requestId));   
  }

  GetCurrentUser() {
    this.requestService.getCurrentUser().subscribe({
      next: (user: UserInformation) => {
        this.currentUser = user;
      },
      error: (err: any) => {        
        this.errorMessage = err.error;
      },
      complete: () => { }
    });
  }

  filterReviewers(val: string): Observable<UserInformation[]> {
    this.errorMessage = "";
    // call the service which makes the http-request
    return this.getReviewers(val)
      .pipe(
        map(response => response.filter((option: UserInformation) => {
          this.isReviewerLoading = false;
          return option.displayName;
        }))
      )
  }

  getReviewers(val: string) {
    this.isReviewerLoading = true;
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const searchTerm = new HttpParams().set('searchTerm', val);
    return this.reviewersOptions.length ?
      of(this.reviewersOptions) :
      this.requestService.getUserPerProject(searchTerm).pipe(tap(data => this.reviewersOptions = data))
  }

  onAddReviewerSelected(event: MatAutocompleteSelectedEvent) {
    var user = this.reviewersOptions.find(x => x.adsId === event.option.value) as UserInformation;

    if (user.isContainer) {
      this.requestService.getTeamMembers(user.adsId, this.project).subscribe({
        next: (data) => {
          for (let reviewerData of data) {
            this.pushToReviewersArray({
              reviewer: reviewerData.displayName, reviewerId: reviewerData.adsId, relatedScope: '', isApprover: true, unique_Reviewer : reviewerData.emailAddress
            });
          }          
        }
      })
    }
    else {      
      this.pushToReviewersArray({
        reviewer: user.displayName, reviewerId: user.adsId, relatedScope: '', isApprover: true, unique_Reviewer : user.emailAddress
      });
    }

    this.reviewersOptions = [];
    this.addReviewerControl.setValue("");
    event.option.value = '';
  }

  pushToReviewersArray(reviewer: RequestReviewerViewModel) {
    var currentUserAdsId = this.currentUser.adsId;

    if (currentUserAdsId === reviewer.reviewerId) {
      this.errorMessage = 'The selected user is requestor of this request.';
      return;
    }

    if (this.moderatorIds.indexOf(reviewer.reviewerId) >= 0) {
      this.errorMessage = 'The selected user is moderator of this request.';
      return;
    }

    if (this.newReviewersList.find(r => r.reviewerId === reviewer.reviewerId) === undefined) {
      this.newReviewersList.push(reviewer);     
      this.isModified = true;
    } else {
      this.errorMessage = "This reviewer is already selected!";
    }
  }

  removeReviewer(reviewer: RequestReviewerViewModel) {
    const index = this.newReviewersList.indexOf(reviewer);
    this.newReviewersList.splice(index, 1);
    this.isModified = true;
  }

  onSaveClick() {
    this.isReviewerLoading = true;
    this.reviewRequest.requestId = Number(this.requestId);
    this.reviewRequest.reviewers = this.newReviewersList;

    this.requestService.modifyReviewersOfRequest(this.reviewRequest).subscribe({
      next: (response: ModifiedRequest) => {
        this.reviewersProgressList = [];
        this.getRequestReviewersProgress(Number(this.requestId));
        this.reviewersList = [];
        this.reviewersList = response.reviewers;        

        this.isReviewerAddedSuccessfully = true;
        this.newReviewersList = [];
        this.isEditable = false;
        this.isModified = false;
      },
      error: (error: any) => { this.errorMessage = error.message; },
      complete: () => {
        this.isReviewerLoading = false;
        this.reviewersOptions = [];
        this.addReviewerControl.setValue("");
        this.errorMessage = "";
      }
    });
  }

  onCancelClick() {
    this.isEditable = false;
    this.isModified = false;
    this.newReviewersList = [];
    this.reviewersOptions = [];
    this.addReviewerControl.setValue("");
    this.errorMessage = "";
  }
}
